import { useSnapshot } from "valtio"
import { AppStore } from "./store"

export const useStoreActions = () => {
  const { selectedObject, selectedFloor } = useSnapshot(AppStore)

  const toggleSelectedObject = () => {
    AppStore.selectedObject = selectedObject === 'А' ? 'Б' : 'А'
  }

  const onHoverOverObject = (hoverObject: 'А' | 'Б') => {
    AppStore.selectedObject = hoverObject
  }

  const incrementSelectedFloor = () => {
    AppStore.selectedFloor = selectedFloor < 15 ? selectedFloor + 1 : selectedFloor
  }

  const decrementSelectedFloor = () => {
    AppStore.selectedFloor = selectedFloor > 3 ? selectedFloor - 1 : selectedFloor
  }

  const onHoverOverFloor = (hoverFloor: number) => {
    AppStore.selectedFloor = hoverFloor
  }

  const onHoverOverApartment = (apartment: number) => {
    AppStore.selectedApartment = apartment
  }

  const goPrevPage = (page: 10 | 21 | 22 | 31 | 32) => {
    AppStore.currentPage = page
  }

  return {
    toggleSelectedObject,
    onHoverOverObject,
    incrementSelectedFloor,
    decrementSelectedFloor,
    onHoverOverFloor,
    onHoverOverApartment,
    goPrevPage,
  }
}
